import { ISelectOption } from './ISelectOption';

export const convertOptionsToStrings = (items: ISelectOption[]) => items.map(option => option.value);
